<template>
  <div>
    <!-- <el-input
      class="search-el"
      size="mini"
      v-model="query.search"
      placeholder="昵称/手机号/用户ID"
      :clearable="true"
    ></el-input> -->
    <el-input
      class="search-el"
      size="mini"
      v-model="query.user_id"
      placeholder="用户ID"
      :clearable="true"
    ></el-input>
    <el-input
      class="search-el"
      size="mini"
      v-model="query.mobile_phone"
      placeholder="手机号"
      :clearable="true"
    ></el-input>
    <el-input
      class="search-el"
      size="mini"
      v-model="query.nickname"
      placeholder="昵称"
      :clearable="true"
    ></el-input>
    <el-select
      class="search-el"
      size="mini"
      v-model="query.platform"
      placeholder="终端"
      :clearable="true"
    >
      <el-option label="全部终端" value="">全部终端</el-option>
      <el-option label="Android" value="1">Android</el-option>
      <el-option label="IOS" value="2">IOS</el-option>
      <el-option label="H5" value="3">H3</el-option>
    </el-select>
    <el-select
      class="search-el"
      size="mini"
      v-model="query.level_id"
      placeholder="会员等级"
      :clearable="true"
    >
      <el-option label="全部用户" value="">全部用户</el-option>
      <el-option label="普通用户" value="0">普通用户</el-option>
      <el-option label="7天免费会员" value="2">7天免费会员</el-option>
      <el-option label="365幸福会员" value="10">365幸福会员</el-option>
    </el-select>

    <el-date-picker
      class="search-el"
      size="mini"
      v-model="query.date_timestamp"
      value-format="yyyy-MM-dd HH:mm:ss"
      type="datetimerange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="注册开始日期"
      end-placeholder="截止日期"
      :picker-options="pickerOptions"
      :default-time="['00:00:00', '23:59:59']"
    >
    </el-date-picker>

    <el-select
      class="search-el"
      size="mini"
      v-model="query.from"
      placeholder="用户来源"
      :clearable="true"
    >
      <el-option label="全部来源" value="">全部来源</el-option>
      <!-- <el-option label="灵动生活APP+H5" value="fenSpace">灵动生活APP+H5</el-option> -->
      <el-option label="灵动生活APP" value="fenSpaceAPP">灵动生活APP</el-option>
      <el-option label="灵动生活H5" value="fenSpaceH5">灵动生活H5</el-option>
      <el-option label="抖音直播" value="backend_activity_import_dy">抖音直播</el-option>
      <el-option label="抖音短视频" value="backend_activity_import_dy_short">抖音短视频</el-option>
      <el-option label="视频号直播" value="backend_activity_import_wxvideo">视频号直播</el-option>
      <el-option label="视频号短视频" value="backend_activity_import_wxvideo_short">视频号短视频</el-option>
      <el-option label="原研习社公众号继承" value="oldUser">原研习社公众号继承</el-option>
      <el-option label="小鹅通导入" value="xiaoetong">小鹅通导入</el-option>
      <el-option label="抖音小风车" value="backend_activity_import_dy_xiaofengche">抖音小风车</el-option>
    </el-select>

    <el-select
      class="search-el"
      size="mini"
      v-model="query.agent_id"
      placeholder="请选择"
      filterable
      :clearable="true"
    >
      <el-option label="全部分会" value=""></el-option>
      <el-option
        v-for="item in agentList"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>

    <el-select
        class="search-el"
        size="mini"
        v-model="query.total_duration_range"
        placeholder="听课时长"
        :clearable="true"
    >
      <el-option label="学习时长" value="">学习时长</el-option>
      <!-- <el-option label="灵动生活APP+H5" value="fenSpace">灵动生活APP+H5</el-option> -->
      <el-option label="大于1000小时" value="1000">大于1000小时</el-option>
      <el-option label="大于500小时" value="500">大于500小时</el-option>
      <el-option label="大于100小时" value="100">大于100小时</el-option>
      <el-option label="大于10小时" value="10">大于10小时</el-option>
    </el-select>

    <el-button type="primary" size="mini" @click="getList()"> 查询 </el-button>
    <el-button type="primary" size="mini" @click="exportUser()">
      导出
    </el-button>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
      >
        <el-table-column
          label="用户ID"
          align="center"
          min-width="20%"
        >
        <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="toUserInfo(row.id)">
              <div>{{ row.id }}</div>
            </el-button>
        </template>
        </el-table-column>
        <el-table-column
          label="昵称"
          align="center"
          min-width="20%"
          prop="nickname"
        ></el-table-column>
<!--        <el-table-column-->
<!--            label="微信昵称"-->
<!--            align="center"-->
<!--            min-width="20%"-->
<!--            prop="name_convert"-->
<!--        ></el-table-column>-->
        <el-table-column label="头像" align="center" min-width="20%">
          <template slot-scope="{ row }">
            <img :src="row.avatar" style="width: 40px" alt="" />
          </template>
        </el-table-column>
        <el-table-column
          label="学习时长"
          align="center"
          min-width="20%"
          prop="total_duration"
        >
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="toStudyList(row.id)">
              <div>{{ row.total_duration }}</div>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="会员级别"
          align="center"
          min-width="20%"
          prop="level_msg"
        ></el-table-column>
        <el-table-column
          label="会员开始时间"
          align="center"
          min-width="20%"
          prop="vip_begin_at"
        ></el-table-column>
        <el-table-column
          label="会员截止时间"
          align="center"
          min-width="20%"
          prop="vip_expire_at"
        ></el-table-column>
        <el-table-column
          label="注册时间"
          align="center"
          min-width="20%"
          prop="created_at"
        ></el-table-column>
        <el-table-column
          label="终端"
          align="center"
          min-width="20%"
          prop="platform"
        ></el-table-column>
        <el-table-column
          label="用户来源"
          align="center"
          min-width="20%"
          prop="user_from_msg"
        ></el-table-column>
        <el-table-column
          label="唯一码"
          align="center"
          min-width="20%"
          prop="user_code"
        ></el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <el-button type="primary" size="small" @click="searchCount()">查询总条数</el-button>
    </el-row>
  </div>
</template>

<script>
import { getUserList} from "@/api/user";
import { getAllAgent } from "@/api/agent";
const axios = require('axios');

export default {
  data: function () {
    return {
      list: [],
      loading: false,
      total: 0,
      agentList: [],
      query: {
        page: 1,
        limit: 10,
        user_id: "",
        mobile_phone: "",
        nickname: "",
        search: "",
        platform: "",
        level_id: "",
        start_at: "",
        end_at: "",
        from: "",
        total_duration_range: "",
        export: 0,
        type: 1
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const start = new Date(new Date(new Date().toLocaleDateString()).getTime());
              const end = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1);
              picker.$emit('pick', [start, end]);
            }
          }, 
          {
            text: '昨天',
            onClick(picker) {
              const start = new Date(new Date(new Date().toLocaleDateString()).getTime()-24*60*60*1000);
              const end = new Date(new Date(new Date().toLocaleDateString()).getTime()-1);
              picker.$emit('pick', [start, end]);
            }
          }, 
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  created: function () {
    this.getList();
    getAllAgent().then((res) => {
      if (res.status === "2000") {
        this.agentList = res.data.list;
      }
    });
  },
  methods: {
    getList() {
      this.loading = true;
      this.query.type = 1;
      getUserList(this.query).then((response) => {
        this.list = response.data.list;
        if (this.total == 0) {
          this.total = response.data.total;
        }
        this.loading = false;
      });
    },
    toInfo(id = 0) {
      this.$router.push({
        path: "/user/info",
        query: {
          id: id,
          admin_id: this.$route.query.admin_id,
          admin_name: this.$route.query.admin_name,
        }
      });
    },
    toUserInfo(id = 0) {
      this.$router.push({
        path: "/user/userInfo",
        query: {
          id: id,
          admin_id: this.$route.query.admin_id,
          admin_name: this.$route.query.admin_name,
        }
      });
    },

    toStudyList(id = 0) {//去学习课程列表页
      this.$router.push({
        path: "/user/studyList",
        query: {
          id: id,
          admin_id: this.$route.query.admin_id,
          admin_name: this.$route.query.admin_name,
        }
      });
    },

    searchCount() {
      this.query.type = 2
      getUserList(this.query).then((response) => {
        this.total = response.data.total;
      });
    },

    exportUser() {
      this.query.export = 1;
      this.loading = true;

      axios({
        method: 'post',
        url: '/backend/user/getUserList',
        data: this.query,
        responseType: 'blob'
      }).then((res) => {
        //console.log(res)
        const link = document.createElement('a')
        let blob = new Blob([res.data],{type: 'application/vnd.ms-excel'});
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', '用户列表.xls')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.loading = false;
        this.query.export = 0;
      }).catch(error => {
        this.$Notice.error({
          title: '错误',
          desc: '网络连接错误'
        })
        console.log(error)
      })
    }
  },
  mounted() {},
};
</script>